<template>
	<NuxtLink v-if="slug != null"
						:to="localePath(`/${slug.current}`)"
						class="button">
		{{ buttonText }}  &rarr;
	</NuxtLink>
</template>

<script setup>
import { useI18n, useLocalePath } from '#imports'
import {computed} from "vue";
const { locale } = useI18n()
const localePath = useLocalePath()
const props = defineProps({
	specific: Object,
	default: Object,
	slug: Object
})
let buttonText
if(props.specific != null) {
	buttonText = computed(() => locale.value === 'en' ? props.specific.en : props.specific.jp)
} else {
	buttonText = computed(() => locale.value === 'en' ? props.default.en : props.default.jp)
}
</script>

<style lang="scss">
@use '@/assets/sass/variables.scss' as v;
.button {
	@include v.button;
	margin: 1rem 0 3rem 0;
	@include v.respond-to('large') {
		margin: 2rem 0 0 0;
	}
}
</style>
